<template>
    <div class="ticket-status-switcher">
        <div
            v-for="(status, index) in statusList"
            :key="index"
            :class="[
                'status-box',
                {
                    active: index <= currentStatusIndex,
                    highlight: index <= hoverIndex && hoverIndex !== -1,
                },
            ]"
            @click="updateStatus(index)"
            @mouseover="setHoverIndex(index)"
            @mouseleave="resetHoverIndex"
        >
            {{ formatStatusText(status) }}
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "TicketStatusSwitcher",
    props: {
        currentStatus: {
            type: String,
            required: false,
        },
        statusList: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            hoverIndex: -1,
        };
    },
    computed: {
        currentStatusIndex() {
            return this.statusList.map((x) => x.title).indexOf(this.currentStatus);
        },
    },
    methods: {
        updateStatus(index) {
            console.log("updateStatus", this.statusList[index].title);
            this.$emit("update-status", this.statusList[index].title);
        },
        setHoverIndex(index) {
            this.hoverIndex = index;
        },
        resetHoverIndex() {
            this.hoverIndex = -1;
        },
        formatStatusText(status) {
            if (this.statusList.length < 6) {
                return status.label || status.title;
            }

            const maxLength = 8;
            const statusText = status.label || status.title;

            if (statusText.length <= maxLength) {
                return statusText;
            }
            return `${statusText.substring(0, maxLength)}...`
        },
    },
});
</script>

<style scoped lang="scss">
.ticket-status-switcher {
    display: flex;
    align-items: center;
    gap: 2px;
}

.status-box {
    padding: 4px 12px;
    min-width: 80px;
    max-width: 120px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to right, #4e8cff 50%, #91a2b69e 50%);
    background-size: 200% 100%;
    background-position: right bottom;
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.9rem;
}

.status-box.active,
.status-box.highlight {
    background-position: left bottom;
}

.status-box:first-child {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
}

.status-box:last-child {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
}
</style>
